// extracted by mini-css-extract-plugin
export default {"divider":"Br60ieQoh3n9jRS5aTgN"};